import { useContext } from 'react';
import BasketContext, { BasketStoreProps } from './basket-context';

const useBasket = () => useContext<BasketStoreProps>(BasketContext);

export default useBasket;
